import { Injectable } from "@angular/core";
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateFormat {
  /**
 * Converte o objeto de data/hora do seletor para uma String UTC
 * @param {Object} input - Objeto com date {year, month, day} e start {hour, minute, second}
 * @returns {string} - Data em formato UTC: "2026-06-05T17:00:00Z" (Exemplo considerando fuso -3)
 */
  convertToUTC(input: any): string | null {
    if (!input || !input.date || !input.start) return null;

    const localDate = moment({
      year: input.date.year,
      month: input.date.month - 1,
      day: input.date.day,
      hour: input.start.hour,
      minute: input.start.minute,
      second: input.start.second
    });

    return localDate.utc().format();
  }
}